import { createTheme } from "@mui/material/styles";
import typography from "./typography";

/* eslint-disable import/no-unresolved, import/no-webpack-loader-syntax */
import vars from "!!sass-vars-to-js-loader!../assets/core/_variables-mui.scss";

export const DayTheme = createTheme({
  palette: {
    mode: "light",
    text: {
      primary: "#3b3e66",
    },
    colors: {
      text1: "#3b3e66",
      grey1: "#dedfe3",
      label: "#3b3e66",
      borderColor: vars.bgElementsLight,
      chipBg: vars.bgElementsLight,
      borderColorList: "#B5B5B5",
    },
    // default: {
    //   main: vars.primary
    // },
    primary: {
      main: vars.primary,
    },
    topBar: {
      main: "#FFFEFC",
      submenu: "#1977D4",
      underline: "#FFFEFC",
    },
    grey: {
      300: vars.inheritDefault1,
      A100: vars.inheritDefault2,
    },
    secondary: {
      main: vars.secondary,
    },
    error: {
      main: "#d32f2f",
      light: "#d32f2f",
      dark: "rgb(179, 39, 39)",
    },
    success: {
      main: vars.green,
    },
    warning: {
      main: vars.orange,
    },
    helpers: {
      primary: vars.blue,
      main: "rgba(25, 46, 91, .035)",
    },
    customBg: "#1977D4",
    bg: vars.bgLight,
    bgElements: vars.bgElementsLight,
    colorFont: "#000",
    toolbarColor: vars.primary,
    contrastThreshold: 3,
    tonalOffset: 0.1,
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: "normal",
        },
        text: {
          paddingLeft: "14px",
          paddingRight: "14px",
        },
        containedSizeSmall: {
          paddingLeft: "14px",
          paddingRight: "14px",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: vars.second,
          padding: "8px 16px",
          fontSize: "13px",
        },
        arrow: {
          color: vars.second,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: "#1976d2",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem 0.7rem 1rem 1.5rem",
          color: vars.inheritDefault1,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label": {
            // color: "#000",
          },
          "& .MuiInputBase-root": {
            // color: "#000",
            // backgroundColor: vars.inheritDefault,
          },
          "& .MuiInputBase-input": {
            color: "#000", // Set desired text color here
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "& .MuiOutlinedInput-root": {
            maxHeight: "50px",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root": {
            // color: "#000",
          },
          "& .MuiSelect-select": {
            // color: "#000",
            // backgroundColor: vars.inheritDefault,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#000",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          color: "#000",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          marginTop: "1em",
          marginBottom: "1em",
        },
        selectLabel: {
          marginTop: "1em",
          marginBottom: "1em",
        },
      },
    },
  },
  typography,
  colors: {
    errorContrast: "#ffffff",
    grey1: "#dedfe3",
  },
  card: {
    bg: "#fff",
    hr: "#dedfe3",
    warrantColor: "#D33D1D",
  },
  button: {
    color: "#1976d2",
  },
  accordion: {
    background: "#fff",
    backgroundColor: "#d5d5d5",
    textColor: "#3b3e66",
  },
  content: {
    bg: "#e5e5e5",
  },
});

export const NightTheme = createTheme({
  palette: {
    mode: "dark",
    text: {
      primary: "#d4d6d7",
      button: "#d4d6d7",
    },
    // default: {
    //   main: '#d4d6d7'
    // },
    primary: {
      main: vars.primary,
    },
    topBar: {
      main: "#1977D4",
      submenu: "#1977D4",
      topBar: "#1977D4",
    },
    grey: {
      300: vars.inheritDefault1,
      A100: vars.inheritDefault2,
    },
    secondary: {
      main: vars.secondary,
    },
    error: {
      main: "#d32f2f",
      light: "#d32f2f",
      dark: "rgb(179, 39, 39)",
    },
    success: {
      main: vars.green,
    },
    warning: {
      main: vars.orange,
    },
    helpers: {
      primary: vars.blue,
      main: "rgba(25, 46, 91, .035)",
    },
    bg: vars.bgDark,
    customBg: "#515151",
    bgElements: vars.bgElementsDark,
    colorFont: "#fff",
    toolbarColor: "#748EEB",
    contrastThreshold: 3,
    tonalOffset: 0.1,
    colors: {
      grey1: "#343434",
      borderColor: "#7c7c7c",
      chipBg: vars.bgElementsLight,
      text1: "#d4d6d7",
      label: "#d4d6d7",
      borderColorList: "#7c7c7c",
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": { color: "#fff" },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&:hover": { color: "#fff" },
        },
      },
    },
    MuiButton: {
      backgroundColor: "#515151",
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: "normal",
        },
        text: {
          paddingLeft: "14px",
          paddingRight: "14px",
        },
        containedSizeSmall: {
          paddingLeft: "14px",
          paddingRight: "14px",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: vars.second,
          padding: "8px 16px",
          fontSize: "13px",
        },
        arrow: {
          color: vars.second,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        regular: {
          minHeight: "80px",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          backgroundColor: "#1976d2",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "1rem 0.7rem 1rem 1.5rem",
          color: vars.inheritDefault1,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& label": {
            // color: "#fff",
          },
          "& .MuiInputBase-root": {
            // color: "#fff",
            // backgroundColor: vars.inheritDefault,
          },
          "& .MuiInputBase-input": {
            color: "#fff", // Set desired text color here
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fff",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "& .MuiOutlinedInput-root": {
            maxHeight: "50px",
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root": {
            // color: "#fff",
          },
          "& .MuiSelect-select": {
            // color: "#fff",
            // backgroundColor: vars.inheritDefault,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#fff",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: vars.primary,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#121212",
          color: "#fff",
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          marginTop: "1em",
          marginBottom: "1em",
        },
        selectLabel: {
          marginTop: "1em",
          marginBottom: "1em",
        },
      },
    },
  },
  typography,
  colors: {
    errorContrast: "#f7f7f7",
    grey1: "#343434",
  },
  card: {
    bg: "#fff",
    hr: "#343434",
    warrantColor: "#D33D1D",
  },
  button: {
    color: "#fff",
  },
  accordion: {
    background: "#424242",
    backgroundColor: "#1e2e3a",
    textColor: "#d4d6d7",
  },
  content: {
    bg: "#212325",
  },
});
